<template>
    <b-nav-form @submit.prevent="$emit('input', $event)">
        <label :for="id" class="sr-only">
            {{ $t('Search') }}
        </label>

      <search-input-group :id="id" :value="value" @input="$emit('input', $event)" />
        <input hidden type="submit">
    </b-nav-form>
</template>
<script>
import SearchInputGroup from "@/components/SearchInputGroup";

export default {
        name: 'SearchInput',
      components: {SearchInputGroup},
      props: {
            value: {
                type: String,
                default: null
            },

            id: {
                type: String,
                default: 'search'
            }
        }
    }
</script>
